export default __webpack_public_path__ + "static/media/Metropolis-Light.d9119620.woff2";